import React, { useEffect, useRef, useState } from 'react'
import { Column } from 'primereact/column'
import HobbyService from "./hobbyService"
import FormList from 'base/FormList'

export default function HobbyList() {

    const [service] = useState(() => new HobbyService())
    const toast = useRef(null)
    const searchData = {
        pkName: 'codigo_hobb',
        dsName: 'descricao_hobb',
        mainField: { name: 'descricao_hobb', label: 'Descrição' },
        advFields: [
            { name: 'codigo_hobb', label: 'Código', type: 'integer', inputMode: 'numeric' },
            { name: 'descricao_hobb', label: 'Descrição', type: 'string', inputMode: 'text' },
        ]
    }

    useEffect(() => {
    }, [service])

    return (
        <FormList service={service} toast={toast} searchData={searchData} showActions={true}>
            <Column field="descricao_hobb" sortable header="Descrição"></Column>
        </FormList >
    )
}
